export default __webpack_public_path__ + "static/media/book-main.c9f5bbf8.png";